module.exports = __webpack_public_path__ + "static/media/cart18.84b58fbc.svg";